import { error } from "toastr"
import {

  GET_INVOICE_HISTORY_FAIL,
  GET_INVOICE_HISTORY_SUCCESS,

  GET_INVOICE_HISTORY_DETAIL_SUCCESS,
  GET_INVOICE_HISTORY_DETAIL_FAIL,

  DELETE_INVOICE_HISTORY_SUCCESS,
  ADD_INVOICE_HISTORY_SUCCESS,
  ADD_INVOICE_HISTORY_FAIL,
  SET_INVOICE_HISTORY_LOADING

} from "./actionTypes"

const INIT_STATE = {
  invoiceHistoryes: [],
  invoiceHistory: {},
  error:{},
  loading:false
}

const InvoiceHistoryes = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_INVOICE_HISTORY_SUCCESS:
      return {
        ...state,
        invoiceHistoryes: action.payload,
      }
    case GET_INVOICE_HISTORY_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    case GET_INVOICE_HISTORY_DETAIL_SUCCESS:
      return {
        ...state,
        invoiceHistory: action.payload,
      }

    case GET_INVOICE_HISTORY_DETAIL_FAIL:
      return {
        ...state,
        error: action.payload,
      }

    case DELETE_INVOICE_HISTORY_SUCCESS:
      return {
        ...state,
        invoiceHistoryes: state.invoiceHistoryes.docs.filter(
          invoiceHistory => invoiceHistory._id !== action.payload.id
        ),
      }

    // case INVOICE_HISTORY:
    //    return {
    //     ...state,
    //     invoiceHistory: action.payload,
    //   }

    case SET_INVOICE_HISTORY_LOADING:
       return {
        ...state,
        loading: !state.loading,
      }

    case ADD_INVOICE_HISTORY_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}

export default InvoiceHistoryes
